(function () {
  'use strict';

  angular
    .module('app.account-wishlist', ['directive.ngclipboard'])

    .component('accountWishList', {
      bindings: {
        device: '<'
      },
      /* @ngInject */
      templateUrl: ["AccountService", function (AccountService) {
        return AccountService.getLinks().AccountWishList;
      }],
      /* @ngInject */
      controller: ["$element", "$scope", "$rootScope", "$timeout", "$window", "whishListService", "AppService", "AccountService", "RoutesService", "HttpService", "productsGridService", "ModalService", "toastr", function ($element, $scope, $rootScope, $timeout, $window, whishListService, AppService, AccountService, RoutesService, HttpService, productsGridService, ModalService, toastr) {
        var ctrl = this;

        AccountService.initAccount(ctrl);

        var tmpId = 'pg_' + productsGridService.getId();
        $element.find('.products-list').attr('id', tmpId);

        ctrl.commentPopover = '/Template/Account/AccountWishListComment';

        ctrl.$onInit = function () {
          ctrl.loading = true;
          $scope.device = ctrl.device;
          loadData();
        };

        // Translate
        var tplTranslate = {};
        $element.children('.translate').children().each(function () {
          var $this = $(this);
          tplTranslate[$this.attr('key')] = $this.html();
        });

        ctrl.empty = function () {
          $rootScope.$broadcast('showPageLoader', true);
          HttpService.post({
            url: '/WishList/Empty',
            data: {}
          })
          .then(function (response) {
            if (response.status === 'OK') {
              ctrl.Products = [];
              ctrl.count = 0;
              whishListService.reset();
            }
            $rootScope.$broadcast('showPageLoader', false);
          })
          .catch(function (error) {
            console.error(error);
          });
        };

        ctrl.removeProduct = function (id) {
          ModalService.show(
            '/Template/Account/ModalRemoveWishListProduct',
            {
              action: function () {
                removeProduct(id);
              }
            },
            null,
            'modalRemoveWishListProductCtrl'
          );
        };

        ctrl.saveRate = function (item) {
          item.rateLoading = true;
          HttpService.post({
            url: '/WishList/Rating',
            data: {
              IDProduct: item.Product.IDProduct,
              Rate: item.Rate
            }
          })
          .then(function (response) {
            if (response.satus === 'OK') {
              AppService.getTranslate()
                .then(function (translate) {
                  toastr.success('', translate.messages.SavedChanges, {
                    allowHtml: true,
                    extraData: {
                      template: 'toast_message.tpl'
                    }
                  });
                });
            }
            item.rateLoading = false;
          })
          .catch(function (error) {
            console.error(error);
          });
        };

        ctrl.editComment = function (item) {
          item.editedComment = item.Comment;
          item.commentIsOpen = true;
        };
        ctrl.saveComment = function (item) {
          item.commentLoading = true;
          HttpService.post({
            url: '/WishList/Comment',
            data: {
              IDProduct: item.Product.IDProduct,
              Comment: item.editedComment
            }
          })
          .then(function (response) {
            if (response.status === 'OK') {
              item.Comment = item.editedComment;
              item.commentIsOpen = false;
              item.hasComment = item.Comment !== '';
              $timeout(function () {
                productsGridService.resizeGrid(tmpId, ctrl.device.size, false);
              });
              AppService.getTranslate()
                .then(function (translate) {
                  toastr.success('', translate.messages.SavedChanges, {
                    allowHtml: true,
                    extraData: {
                      template: 'toast_message.tpl'
                    }
                  });
                });
            }
            item.commentLoading = false;
          })
          .catch(function (error) {
            console.error(error);
          });
        };

        ctrl.addAllToCart = function () {
          $rootScope.$broadcast('showPageLoader', true);
          AppService.getParams()
            .then(function (params) {
              $rootScope.$broadcast('showPageLoader', false);
              var products = [];
              _.each(ctrl.Products, function (item) {
                if (item.Product.AllowAddToCart) {
                  products.push({
                    idProduct: item.Product.IDProduct,
                    Price: AppService.getProductPrice(item.Product.Price, item.Quantity),
                    showTTCPrice: params.Visitor.CardType.ShowTTCPrice,
                    quantity: item.Quantity,
                    designation: item.Product.Designation,
                    img: item.Product.IDPicture,
                    URL: item.Product.URL
                  });
                }
              });

              ModalService.close();
              ModalService.show(
                '/Template/Modal/ModalAddToCart',
                products,
                null,
                'modalAddToCartCtrl',
                null,
                null,
                {
                  cartLink: '/' + RoutesService.getUrlByName('Cart')
                }
              );

              AppService.addToCart(products)
                .then(function (response) {
                  if (response.status === 'OK') {
                    AppService.updateParams(response.results);
                  } else {
                    AppService.getTranslate()
                      .then(function (translate) {
                        toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                          allowHtml: true,
                          extraData: {
                            template: 'toast_message.tpl'
                          }
                        });
                      });
                  }
                })
                .catch(function (error) {
                  console.error(error);
                });
            })
            .catch(function (error) {
              console.error(error);
            });

        };

        ctrl.onSuccess = function (e, message) {
          e.clearSelection();
          toastr.success('', decodeURI(message), {
            allowHtml: true,
            extraData: {
              template: 'toast_message.tpl'
            }
          });
        };

        ctrl.addProduct = function (product) {
          if (!product.IsGroupingProduct) {
            $rootScope.$broadcast('showPageLoader', true);
            HttpService.post({
              url: '/WishList/Add',
              data: product.IDProduct
            })
            .then(function (response) {
              if (response.status === 'OK') {
                toastr.success('', tplTranslate.addedToList, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
                reloadProducts();
                whishListService.reset();
              }
              $rootScope.$broadcast('showPageLoader', false);
            })
            .catch(function (error) {
              console.error(error);
            });
          } else {
            ModalService.show(
              '/Template/Modal/ModalQuickView',
              {
                url: 'choose-p-' + product.IDProduct,
                selectPrimary: true,
                idGroupingProduct: product.IDProduct,
                action: ctrl.addPrimary
              },
              'lg',
              'modalWishlistSelectController',
              null,
              ctrl.device,
              {
                translate: tplTranslate
              }
            );
          }
        };

        ctrl.addPrimary = function (id) {
          ctrl.addProduct({
            IDProduct: id,
            IsGroupingProduct: false
          });
        };

        // Functions
        function loadData() {
          getProducts()
            .then(function () {
              ctrl.loading = false;
            });
        }

        function reloadProducts() {
          ctrl.loadingProducts = true;
          getProducts()
            .then(function () {
              $timeout(function () {
                productsGridService.resizeGrid(tmpId, ctrl.device.size, false);
                ctrl.loadingProducts = false;
              });
            })
            .catch(function (error) {
              console.error(error);
            });
        }

        function getProducts() {
          return HttpService.get({
            url: '/WishList/Products',
            cache: false
          })
          .then(function (response) {
            ctrl.Products = response.results.Products;
            ctrl.Total = response.results.Total;
            ctrl.PublicLink = response.results.PublicLink;

            ctrl.count = ctrl.Products.length;

            ctrl.addAllEnabled = true;
            _.each(ctrl.Products, function (line) {
              line.hasComment = line.Comment !== undefined && line.Comment !== '';
              if (!line.Product.AllowAddToCart) {
                ctrl.addAllEnabled = false;
              }
            });

            return true;
          })
          .catch(function (error) {
            console.error(error);
          });
        }

        function removeProduct(id) {
          $rootScope.$broadcast('showPageLoader', true);
          HttpService.post({
            url: '/WishList/Remove',
            data: id
          })
          .then(function (response) {
            if (response.status === 'OK') {
              whishListService.reset();
              ctrl.Products = response.results.Products;
              ctrl.Total = response.results.Total;
              ctrl.count = ctrl.Products.length;
              ctrl.addAllEnabled = true;
              _.each(ctrl.Products, function (line) {
                if (!line.Product.AllowAddToCart) {
                  ctrl.addAllEnabled = false;
                }
              });
              AppService.getTranslate()
                .then(function (translate) {
                  toastr.success('', translate.messages.SavedChanges, {
                    allowHtml: true,
                    extraData: {
                      template: 'toast_message.tpl'
                    }
                  });
                })
                .catch(function (error) {
                  console.error(error);
                });
              setTimeout(function () {
                $window.dispatchEvent(new Event('resize'));
              });
            }
            $rootScope.$broadcast('showPageLoader', false);
          })
          .catch(function (error) {
            console.error(error);
          });
        }
      }],
      controllerAs: 'accountCtrl'
    })

    /* @ngInject */
    .controller('modalRemoveWishListProductCtrl', ["data", "device", "options", "ModalService", function (data, device, options, ModalService) {
      var ctrl = this;
      ctrl.submit = function () {
        ModalService.close();
        data.action();
      };
    }])

    /* @ngInject */
    .controller('modalWishlistSelectController', ["data", "device", "options", "$scope", "ModalService", function (data, device, options, $scope, ModalService) {
      var ctrl = this;
      ctrl.data = data;
      ctrl.device = device;
      ctrl.options = options;
      ctrl.showLoader = true;
      $scope.device = device;

      ctrl.onLoad = function () {
        ctrl.showLoader = false;
      };

      ctrl.selectPrimary = function () {
        ctrl.data.action(ctrl.data.id);
        ModalService.close();
      };

      ctrl.choiceButton = function () {
        if (!ctrl.data.id || ctrl.data.id === ctrl.data.idGroupingProduct) {
          ctrl.tooltip = ctrl.options.translate.ChooseElementary;
          return true;
        }
        ctrl.tooltip = '';
        return false;
      };

    }])

    /* @ngInject */
    .controller('wishlistPublicController', ["$rootScope", "AppService", "toastr", function ($rootScope, AppService, toastr) {
      var ctrl = this;
      ctrl.productsToCart = [];

      ctrl.init = function (lines) {
        ctrl.addAllEnabled = true;
        _.each(lines, function (line) {
          if (!line.Product.AllowAddToCart) {
            ctrl.addAllEnabled = false;
          }
        });
      };

      ctrl.addProduct = function (idProduct) {
        ctrl.productsToCart.push({
          idProduct: idProduct,
          quantity: 1
        });
      };

      ctrl.addAllProducts = function (event) {
        $rootScope.$broadcast('showPageLoader', true);

        var message = $(event.currentTarget).attr('message');

        AppService.addToCart(ctrl.productsToCart)
          .then(function (response) {
            if (response.status === 'OK') {
              AppService.updateParams(response.results);
              toastr.success('', message, {
                allowHtml: true,
                extraData: {
                  template: 'toast_message.tpl'
                }
              });
            } else {
              AppService.getTranslate()
                .then(function (translate) {
                  toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                    allowHtml: true,
                    extraData: {
                      template: 'toast_message.tpl'
                    }
                  });
                });
            }
            $rootScope.$broadcast('showPageLoader', false);
          })
          .catch(function (error) {
            console.error(error);
          });
      };

    }]);

})();
